<wms-spinner *ngIf="reimportInProgress"></wms-spinner>
<wms-dialog-body class="app-dialog-body dialog-body">
    <div *ngIf="tagsCount?.effectedPaths !== 0" class="dialog-modal-body">
        <div class="wm-form1 reimport-with-issues">
            <div class="dialog-icons">
                <div class="dialog-icons-error">
                    <div class="icon-align "><i class="wms wms-studio-settings wmsicon"></i>
                        <span class="issue-text">
                            <span class="issueCount">{{tagsCount?.effectedPaths}}</span>
                            <span class="issueText ml-9">{{locale.MESSAGE_ENDPOINTS_MODIFIED}}</span></span>
                    </div>
                    <div class="icon-align">
                        <i class="wms wms-error-triangle wmsicon"></i>
                        <span class="display-text">
                            <span class="issueCount">
                                {{tagsCount?.totalIssues}}</span>
                            <span class="issueText">
                                {{locale.LABEL_APP_ERRORS}}</span></span>
                    </div>
                    <div class="icon-align"><i class="wms wms-pages wmsicon"></i><span class="display-text"><span
                                class="issueCount">{{tagsCount?.totalPages}}</span><span
                                class="issueText">{{locale.LABEL_FILES_TREE_PAGES}}</span></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="wm-form1 reimport-with-no-issues">
            <div class="dialog-icons-page">
                {{locale.MESSAGE_REIMPORT_DIALOG}}
            </div>
        </div>
    </div>
    <div *ngIf="tagsCount?.effectedPaths === 0" class="loading-message">
        <div class="alert app-message text-align-center">
            <i class="wms wms-check-circle"></i>
        </div>
        <div class="no-issues">{{locale.LABEL_NO_ISSUES_FOUND}}</div>
        <h3 class="success-messages">{{locale.MESSAGE_SUCESS_NO_ISSUES_FOUND}}</h3>
    </div>

</wms-dialog-body>

<wms-dialog-footer (onModalClose)="closeReImportLoader('reImportLoader')">
    <div class="rowDirection alignEnd">
        <button name="wm-webservice-cancel" class="btn button-secondary app-button marginRight"
            (click)="closeAllDialogs()" [disabled]="disableBtn">
            {{ locale.LABEL_CANCEL }}</button>
        <button name="wm-webservice-reImport" class="button-primary btn app-button" [disabled]="hasSwaggerName()"
            (click)="reImportService()" [disabled]="disableBtn">{{locale.LABEL_RE_IMPORT}}</button>
    </div>
</wms-dialog-footer>
